import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import * as Redux from 'redux'
import * as App from '../../app'
import * as Image from '../../components/image'
import * as Modal from '../../components/modal'
import * as Sortable from '../../components/sortable'
import * as Request from '../../request'
import * as Router from '../../router'
import * as CommunityGrid from './community-grid/reducer'
import * as Constants from './constants'
import * as Types from './types'
import * as Utils from './utils'

export const communitiesReducer = (state: Types.Communities = {}, action: Request.SuccessAction) => {
  switch (action.type) {
    case Request.errorConstant(Constants.FETCH_COMMUNITIES):
      return {}
    case Request.successConstant(Constants.FETCH_COMMUNITIES):
      return Utils.communitiesFromPayload(action.payload.response)
    default:
      return state
  }
}

type Action = App.InitialzingApplicationAction & Router.LocationChange & App.SelectCommunityAction
const selectedCommunityReducer = (state: Types.SelectedCommunity = '', action: Action) => {
  switch (action.type) {
    case App.INITIALIZING_APPLICATION:
    case Router.LOCATION_CHANGE:
      return (action.payload || action.router).pathname.indexOf('community-config') > -1 ?
        (action.payload || action.router).pathname.split('/').slice(-1)[0] :
        state
    case App.SELECT_COMMUNITY:
      return action.communityIdentifier
    default:
      return state
  }
}

const reducerEvent: Sortable.ReducerEvent<Types.EditableConfigRow> = {
  defaultSort: {field: 'data.key', dir: 'asc'},
  requestEvent: Constants.FETCH_COMMUNITY_CONFIG,
}

export const partnerCodeReducer = (state: Types.PartnerCodesState, action: Request.SuccessAction) => {
  switch (action.type) {
    case Request.successConstant(Constants.FETCH_COMMUNITY_CONFIG):
      return action.payload.response.partner_codes
    default:
      return state || []
  }
}

interface SearchAction extends Redux.Action {
  term: string,
}

const emptySearchState: Types.SearchState = {
  term: '',
}

export const searchReducer = (state: Types.SearchState = emptySearchState, action: SearchAction) => {
  switch (action.type) {
    case Constants.UPDATE_SEARCH_STRING:
      return {
        ...state,
        term: action.term,
      }
    default:
      return state
  }
}

export const logoReducer: Redux.Reducer<Types.LogoState> = (state = {logo: null}, action) => {
  switch (action.type) {
    case Request.successConstant(Constants.FETCH_COMMUNITY_CONFIG):
      const logoConfigs = Utils.configsFromResponse(action.payload.response)
        .find((c: Types.ConfigRow) => c.key === Constants.Keys.HeaderImage && isEmpty(c.partner_code))
      return get(logoConfigs, 'value', null)
    default:
      return state
  }
}

const imageReducerEvent: Modal.ReducerEvent<Image.ModalImageData> = {
  initializeState: () => Image.emptyModalImageData,
  requestEvent: Constants.UPLOAD_IMAGE,
}

export const reducer = Redux.combineReducers({
  gridState: Request.reducerChain([
    CommunityGrid.dataReducer,
    CommunityGrid.editReducer,
  ]),
  gridView: Sortable.viewReducer(reducerEvent),
  image: Image.reducer(imageReducerEvent),
  logo: logoReducer,
  partnerCodes: partnerCodeReducer,
  search: searchReducer,
  selectedCommunity: selectedCommunityReducer,
})



// WEBPACK FOOTER //
// ./src/pages/community-config/reducer.ts